import * as actionTypes from './actionTypes'
import * as API from '../api/FindRecCompany'

export const getAllSugeetionByField = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.FIELD_POST_LIST_REQUEST, payload: data})
        return API.getAllSearchByFields(data)
            .then(response => {            	
            	dispatch({type: actionTypes.FIELD_POST_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.FIELD_POST_LIST_ERROR, payload:error})    
            })
    }
}

export const uploadResumeFile = (data,name) => {
    let formData = new FormData();
        formData.append('file',data);
        if(name){
            formData.append('fileName',name);
        }
    return dispatch => {
        dispatch({type: actionTypes.RESUME_FILE_POST_REQUEST, payload: formData})
        return API.resumeUpload(formData)
            .then(response => {             
                dispatch({type: actionTypes.RESUME_FILE_POST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.RESUME_FILE_POST_ERROR, payload:error})    
            })
    }
}

export const reqUestByCity = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.REQUEST_FIND_BY_CITY, payload: data})
    }
}

export const reqUestDeniedByCity = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.REQUEST_DENIED_BY_CITY, payload: data})
    }
}

export const reqSetCity = (data,data2) => {
    return dispatch => {
        dispatch({type: actionTypes.REQUEST_SET_BY_CITY, payload: data,payload2:data2})
     
    }
}


export const getAllCityByCountryAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_CITY_BY_COUNTRY_LIST_REQUEST, payload: data})
        return API.getAllCityByCountry(data)
            .then(response => {             
                dispatch({type: actionTypes.GET_CITY_BY_COUNTRY_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_CITY_BY_COUNTRY_LIST_ERROR, payload:error})    
            })
    }
}

export const getAllCountryAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_COUNTRY_LIST_REQUEST, payload: data})
        return API.getAllCountry(data)
            .then(response => {             
                dispatch({type: actionTypes.GET_COUNTRY_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_COUNTRY_LIST_ERROR, payload:error})    
            })
    }
}

export const getAllCityAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_ALL_CITY_LIST_REQUEST, payload: "data"})
        return API.getAllCity("data")
            .then(response => {             
                dispatch({type: actionTypes.GET_ALL_CITY_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_ALL_CITY_LIST_ERROR, payload:error})    
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/FindRecCompany.js